<template>
  <div class="box">
    <el-button
      @click="back"
      style="margin-bottom:10px"
    >返回</el-button>
    <el-button
      type="primary"
      @click="newman"
      style="margin-bottom:10px"
    >新建用户</el-button>
    <div class="tree">
      <el-table
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column label="电话">
          <template slot-scope="scope">
            <i class="el-icon-phone"></i>
            <span style="margin-left: 10px">{{ scope.row.mobile }}</span>
          </template>
        </el-table-column>

        <el-table-column label="姓名">
          <template slot-scope="scope">
            <el-popover
              trigger="hover"
              placement="top"
              width="350"
            >
              <p>分配权限</p>
              <el-tag
                v-for="(item,i) in  scope.row.auth"
                :key="item.id"
                type="success"
                style="margin-left:3px;margin-right:3px;margin-bottom:6px"
              >
                {{i+1}}.{{ item.name }}
              </el-tag>
              <div
                slot="reference"
                class="name-wrapper"
              >
                <i
                  class="el-icon-user-solid"
                  style="margin-right: 10px"
                ></i>
                <span>{{ scope.row.member_info.name }}</span>
              </div>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="180"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleEdit(scope.$index, scope.row)"
            >分配权限</el-button>
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 权限分配 -->
    <el-dialog
      :title="titleSix"
      :before-close="quxiao"
      :visible.sync="dialogFormVisibleSix"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
    >
      <p style="margin-bottom:10px">手机号：</p>
      <el-input
        v-model="telman"
        placeholder="请输入内容"
        style="margin-bottom:10px"
      ></el-input>
      <p style="margin-bottom:10px">分配权限：</p>
      <el-select
        v-model="authas"
        multiple
        placeholder="请选择"
        style="width:100%"
      >
        <el-option
          v-for="item in optionsauth"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="quxiao">取 消</el-button>
        <el-button
          type="primary"
          @click="editok"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    name: "Authoritycontrol"
    return {
      /* 权限 */
      tableData: [],
      optionsauth: [],
      authas: [],
      ahthid: "",
      telman: "",
      id: "",
      titleSix: "分配权限",
      dialogFormVisibleSix: false,
    }
  },
  created () {
    this.id = this.$route.query.id;
  },
  methods: {
    /* 权限 */
    /* 返回会议 */
    back () {
      this.$router.push({
        path: "/admin/MyMeeting",
        query: {
          editId: this.$route.query.id,
          cur: this.$route.query.cur,
          tab_name: this.$route.query.tab_name
        },
      });
    },
    /* 新建用户 */
    newman () {
      this.titleSix = "新建用户"
      this.ahthid = ""
      this.telman = ""
      this.dialogFormVisibleSix = true
    },
    /* 分配权限 */
    handleEdit (index, row) {
      var _this = this
      _this.dialogFormVisibleSix = true
      for (let i = 0; i < row.auth.length; i++)
      {
        _this.authas.push(row.auth[i].id)
      }
      _this.telman = row.mobile
    },
    /* 删除权限 */
    handleDelete (index, row) {
      var _this = this
      var url = "/ac1/conference/ConfShareAuth/del"
      var params = {
        id: row.id
      }
      _this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$delet(url, params).then(res => {
          if (res.code == 1)
          {
            _this.$message({
              type: 'success',
              message: '删除成功!',
              duration: 1000
            });
            _this.jigou()
          } else
          {
            _this.$message({
              type: 'warning',
              message: res.msg
            });
          }
        })
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除',
          duration: 1000
        });
      });
    },
    /* 确定分配 */
    editok () {
      var _this = this
      var url = "/ac1/conference/ConfShareAuth/add"
      var params = {
        conference_id: "",
        mobile: _this.telman,
        auth: _this.authas
      }
      if (_this.$route.query.editId)
      {
        params.conference_id = _this.$route.query.editId
      } else
      {
        params.conference_id = sessionStorage.getItem("theMeetingId")
      }
      if (params.mobile == "" || params.auth == "")
      {
        _this.$message({
          type: 'warning',
          message: '内容不能为空!',
          duration: 1000
        });
      } else
      {
        _this.$post(url, params).then(res => {
          if (res.code == 1)
          {
            _this.$message({
              type: 'success',
              message: '保存成功!',
              duration: 1000
            });
            _this.jigou()
            _this.authas = []
            _this.telman = ""
            _this.dialogFormVisibleSix = false
          } else
          {
            _this.$message({
              type: 'warning',
              message: res.msg
            });
          }
        })
      }
    },
    /* 取消分配 */
    quxiao () {
      this.dialogFormVisibleSix = false
      this.authas = []
      this.authid = ""
      this.telman = ""
    },
    /* 用户权限*/
    jigou () {
      var _this = this;
      let url = "/ac1/conference/ConfShareAuth/memberLists";
      var params = {
        conference_id: _this.$route.query.editId
      }
      _this.$get(url, params).then((res) => {
        console.log(res);

        if (res.code == 1)
        {
          _this.tableData = res.posts
        }
      });
    },
    /* 全部权限 */
    qxall () {
      var _this = this;
      var url = "/ac1/conference/ConfShareAuth/authList"
      _this.$get(url).then(res => {
        if (res.code == 1)
        {
          _this.optionsauth = res.posts
        }
      })
    },
  },
  mounted () {
    this.jigou();
    this.qxall();
  }
}
</script>

<style scoped>
.box {
  padding: 30px 15px;
}
</style>>
